<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="500"
    :title="popupConfig.title"
    :wrapper-attr="{
      class:
        'css-v2 gc-popup gc-popup-form gc-popup-process-shift-recurring-downtime',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <div class="css-v2 gc-popup-data-grid">
      <dx-data-grid
        @toolbar-preparing="onToolbarPreparing($event)"
        :key="popupConfig.formKey"
        :data-source="getDataSource"
        :columns="getColumns"
        :show-borders="false"
        :height="420"
        :row-alternation-enabled="true"
        :columnChooser="{
          enabled: false,
        }"
        :pager="{ visible: false }"
        :column-auto-width="false"
        :ref="'shifts-tab-grid-downtime'"
        @row-removed="onRowRemoved"
        @editor-preparing="onEditorPreparing"
      >
        <DxEditing
          :allow-deleting="popupConfig.formMode !== 'review'"
          :allow-updating="popupConfig.formMode !== 'review'"
          :mode="'cell'"
          :confirm-delete="false"
        />
      </dx-data-grid>
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import ArrayStore from "devextreme/data/array_store";
import { minutesTo24Hour } from "../../_helpers/ui/helpers";

const baseLine = {
  Description: null,
  StartTime: null,
  EndTime: null,
  DurationMins: null,
  StartTimeEnter: false,
  EndTimeEnter: false,
};

export default {
  mixins: [DataGridMixin],
  components: {},
  data() {
    return {
      IsFormLoaded: false,
      isValid: false,
      loadingVisible: false,
      DownTimeDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    /* Popup Events */
    onShown() {
      this.DownTimeDataSource.clear();
      if (
        this.popupConfig.downTimesData &&
        this.popupConfig.downTimesData._array.length > 0
      ) {
        this.popupConfig.downTimesData._array.forEach((element) => {
          this.DownTimeDataSource.insert(element);
        });
      } else {
        this.DownTimeDataSource = new ArrayStore({
          key: "id",
          data: [],
        });
      }

      if (this.popupConfig.formMode !== "review") {
        let entry = { ...baseLine };
        this.DownTimeDataSource.insert({ ...entry });

        setTimeout(() => {
          this.$nextTick(() => {
            this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
            this.focusOnEditableGridCell("Description");
          });
        }, 100);
      }
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$emit("setIsVisible", false);

      this.DownTimeDataSource.clear();

      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      this.IsFormLoaded = true;
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.formMode === "review") {
        this.onPopupHide(false);
        return;
      }
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        if (confirm) {
          this.onPopupHide();
        }
      }
    },

    async onSavePopupHandler() {
      const downTimes = await this.DownTimeDataSource.load({
        filter: [["Description", "<>", null]],
      });

      const invalidEntries = downTimes.filter(
        (item) => !item.StartTime || !item.EndTime,
      );

      if (invalidEntries.length > 0) {
        await this.$alert(
          "One or more entries have missing Start Time or End Time. Please fill in the required fields.",
          "Validation Error",
        );

        this.focusOnEditableGridCell("StartTime", invalidEntries[0]);
        return;
      } else {
        let StartTime = this.popupConfig.dataModel.StartTime;
        let EndTime = this.popupConfig.dataModel.EndTime;
        const result = this.validateDowntimes(downTimes, StartTime, EndTime);
        if (!result.valid) {
          this.$alert(result.message, "Validation Error");
          return;
        } else this.$emit("onSaveShiftExceptionDowntime", downTimes);
      }
    },

    validateDowntimes(rows, mainShiftStart, mainShiftEnd) {
      const timeRanges = [];

      const shiftStart = new Date(mainShiftStart);
      const shiftEnd = new Date(mainShiftEnd);

      //
      const MINUTES_IN_DAY = 1440;
      const toShiftRelativeMinutes = (timeValue, shiftStartValue) => {
        const t = new Date(timeValue);
        const s = new Date(shiftStartValue);

        const timeMinutes = t.getHours() * 60 + t.getMinutes();
        const shiftStartMinutes = s.getHours() * 60 + s.getMinutes();

        let diff = timeMinutes - shiftStartMinutes;

        // If time is "before" shift start, it belongs to next day
        if (diff < 0) diff += MINUTES_IN_DAY;

        return diff;
      };

      const shiftDurationMinutes =
        toShiftRelativeMinutes(mainShiftEnd, mainShiftStart) || MINUTES_IN_DAY;

      let shiftStartMs = shiftStart.getTime();
      let shiftEndMs = shiftEnd.getTime();

      // If shift crosses midnight, push end to next day
      if (shiftEndMs <= shiftStartMs) {
        shiftEndMs += 24 * 60 * 60 * 1000;
      }

      for (const row of rows) {
        const { Description, StartTime, EndTime } = row;

        const hasDescription = !!Description;
        const hasStart = !!StartTime;
        const hasEnd = !!EndTime;

        // RULE 1 — Description requires times
        if (hasDescription && (!hasStart || !hasEnd)) {
          return {
            valid: false,
            message: `Downtime "${Description}" must have start and end times.`,
            row,
          };
        }

        if (!hasDescription && !hasStart && !hasEnd) continue;

        if (hasDescription && hasStart && hasEnd) {
          let startMin = toShiftRelativeMinutes(StartTime, mainShiftStart);
          let endMin = toShiftRelativeMinutes(EndTime, mainShiftStart);

          // Downtime crosses midnight inside shift
          if (endMin <= startMin) endMin += MINUTES_IN_DAY;

          // ❗ Must be fully inside shift window
          if (startMin < 0 || endMin > shiftDurationMinutes) {
            return {
              valid: false,
              message: `Downtime "${Description}" must be within the shift exception time range.`,
              row,
            };
          }

          timeRanges.push({
            Description,
            startMs: startMin,
            endMs: endMin,
          });
        }
      }

      // RULE 3 — Overlap detection
      timeRanges.sort((a, b) => a.startMs - b.startMs);

      for (let i = 0; i < timeRanges.length - 1; i++) {
        if (timeRanges[i].endMs > timeRanges[i + 1].startMs) {
          return {
            valid: false,
            message: `Downtime "${timeRanges[i].Description}" overlaps with "${
              timeRanges[i + 1].Description
            }".`,
            row: timeRanges[i],
          };
        }
      }

      return { valid: true };
    },

    onEditPopupHandler() {
      this.popupConfig.title = "Edit Schedule Note";
      this.popupConfig.formMode = "edit";
      this.popupConfig.formKey++;
      this.$nextTick(() => {
        // let dataField = "ProcessCode";
        // setTimeout(() => this.setFocusOnField(dataField), 700);
      });
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    addNewRow() {
      this.DownTimeDataSource.insert({ ...baseLine });
    },

    calculateDurationInMinutes(startTime, endTime) {
      if (!startTime || !endTime) return null;

      // Normalize both to the SAME day (1970-01-01)
      const normalizedStart = new Date(
        1970,
        0,
        1,
        startTime.getHours(),
        startTime.getMinutes(),
      );
      let normalizedEnd = new Date(
        1970,
        0,
        1,
        endTime.getHours(),
        endTime.getMinutes(),
      );

      let duration = (normalizedEnd - normalizedStart) / (1000 * 60);

      // SAME TIME = FULL 24 HOURS
      if (duration === 0) {
        duration = 24 * 60;
      }
      // Handle overnight shift (end past midnight)
      else if (duration < 0) {
        duration += 24 * 60;
      }

      return Math.ceil(duration);
    },

    async onRowRemoved(e) {
      if (!e) return;
      let items = await this.DownTimeDataSource.load();
      if (items.length === 0) {
        this.addNewRow();
      } else if (items[items.length - 1].Description !== null) {
        this.addNewRow();
      }
    },

    onEditorPreparing(e) {
      if (e.parentType !== "searchPanel") {
        const { dataField, editorOptions, row } = e;
        // Only wrap handlers if not in the search panel
        if (!editorOptions) return;

        const wrapHandler = (handlerName) => {
          const original = editorOptions[handlerName];
          if (typeof original === "function") {
            editorOptions[handlerName] = (event) => {
              original(event, {
                column: { dataField },
                data: row.data,
                rowIndex: row.rowIndex,
              });
            };
          }
        };

        // Wrap each handler if it exists
        ["onInput"].forEach(wrapHandler);
      }
    },

    focusOnEditableGridCell(dataField, rowData = null) {
      if (this.dataGrid) {
        const dataGrid = this.dataGrid;
        let rowIndex = 0;
        if (rowData) {
          rowIndex = dataGrid.getRowIndexByKey(rowData.id);
        }
        if (rowIndex === -1) return;
        const cellElement = dataGrid.getCellElement(rowIndex, dataField);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, dataField);
        }, 10);
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        // {
        //   widget: "dxButton",
        //   location: "after",
        //   toolbar: "top",
        //   visible:
        //     this.popupConfig.formMode === "review" &&
        //     FeatureStorage.checkPermission("ProductionSchedule", "edit"),
        //   options: {
        //     icon: "edit",
        //     onClick: this.onEditPopupHandler,
        //   },
        // },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          // visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },

    getColumns() {
      return [
        {
          caption: "Description",
          dataField: "Description",
          minWidth: 200,
          width: "100%",
          allowEditing: true,
          cssClass: "edit-cell-textbox-field description-column",
          editorOptions: {
            placeholder: "Enter Description",
            maxLength: 200,
          },
          setCellValue: (newData, value, currentRowData) => {
            if (currentRowData && !currentRowData.Description) {
              this.addNewRow();
            }
            newData.Description = value;
            return newData;
          },
        },
        {
          caption: "Start Time",
          dataField: "StartTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",

            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.DownTimeDataSource,
                flagField: "StartTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.StartTime = value;
            newData.EndTime = null;
            newData.DurationMins = null;
            newData.EndTimeEnter = false; // reset end time input flag when start time changes

            return newData;
          },
        },
        {
          caption: "End Time",
          dataField: "EndTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.DownTimeDataSource,
                flagField: "EndTimeEnter",
              });
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.EndTime = value;

            newData.DurationMins = this.calculateDurationInMinutes(
              currentRowData.StartTime,
              newData.EndTime,
            );

            return newData;
          },
        },
        {
          caption: "Duration (Hrs)",
          dataField: "DurationMins",
          dataType: "number",
          width: 100,
          minWidth: 100,
          allowEditing: false,
          calculateDisplayValue: (data) => {
            if (data.DurationMins > 0) {
              return minutesTo24Hour(data.DurationMins);
            }
            return data.DurationMins || 0;
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Delete",
              icon: "trash",
              visible: this.popupConfig.formMode !== "review",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to delete this entry?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.dataGrid.deleteRow(e.row.rowIndex);
                }
              },
            },
          ],
          visible: this.popupConfig.formMode !== "review",
          width: 50,
          minWidth: 50,
        },
      ];
    },

    getDataSource() {
      return this.DownTimeDataSource._array;
    },
    dataGrid() {
      if (this.$refs["shifts-tab-grid-downtime"]) {
        return this.$refs["shifts-tab-grid-downtime"].instance;
      } else {
        return null;
      }
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val && this.getVisible) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-process-shift-recurring-downtime {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .dx-datagrid-header-panel {
    height: 0px !important;
  }

  .dx-datagrid .dx-datagrid-content {
    .dx-datagrid-table .dx-row .dx-editor-cell:not(.description-column) {
      padding-right: 5px !important;
      padding-left: 5px !important;
    }

    .dx-datebox {
      .dx-placeholder::before {
        padding-left: unset !important;
        padding-bottom: unset !important;
        padding-top: unset !important;
      }
    }
  }

  .edit-cell-textbox-field {
    .dx-placeholder::before {
      padding-left: 0 !important;
      padding-bottom: 2px !important;
    }
  }
}
</style>
